import { Modals } from '@/core'
import { CartModalManager } from './cart-modal.manager'
import { CommonProductButtonView } from './common-product-button.view'

export class GroupButtonView extends CommonProductButtonView {
  constructor(widget: HTMLElement, modalManager: CartModalManager) {
    super(widget, modalManager)

    const button = this.widget.querySelector('.js-add-product')

    if (!button) {
      throw new Error('GroupButton: button missing')
    }

    button.addEventListener('click', (event) => {
      event.preventDefault()
      this.onClick()
    })
  }

  onClick(): void {
    this.modalManager.open(Modals.PRICING)
  }
}
